// import React from "react";
// // import "./customLoader.css";
// import "./CustomLoader.css";

// const CustomLoader = () => {
//   return (
//     <div className="loader-wrapper">
//       <div className="loader_cube loader_cube--color"></div>
//       <div className="loader_cube loader_cube--glowing"></div>
//     </div>
//   );
// };

// export default CustomLoader;
import React from "react";
// import "./customLoader.css";
import "./CustomLoader.css";

const CustomLoader = () => {
  return (
    <div className="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default CustomLoader;
